import React, { useContext, useEffect, useState } from 'react';

import { useParams, useNavigate } from 'react-router-dom';
import { PortfolioContext } from '../../App';
import ProjectImageSlider from './ProjectImageSlider';
const ProjectDetail = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [projects, setProjects] = useState([])
    const project = projects?.find(pro => pro._id === +id)

    useEffect(() => {
        fetch('https://raw.githubusercontent.com/asaduzzaman599/fakedata/main/portfolioData.json')
            .then(res => res.json())
            .then(data => setProjects(data))
    }, [])

    let images;
    if (project) {
        images = [...project?.img]
        images.shift()
    }

    return (
        <div className='container'>

            <h2 className='text-center mb-4 mt-2'>Projects Detail</h2>
            <div className='row  my-5'>

                <div className='col-lg-5 col-12  order-lg-1'>
                    <div className='p-10'>
                        <h4>{project?.name}</h4>
                        <p className='text-secondary mt-3  text-center'>Project Description</p>
                        {

                            project?.about?.map((des, index) => <li key={index}><small>{des}</small></li>)
                        }
                        <hr />
                        <p className='text-secondary mt-3 mb-0 text-center'>Tools</p>
                        <small>{project?.tools}</small>
                        <hr />
                        <div className='mt-4 d-flex gap-4'>

                            <a href={project?.link} target='_blank' className='btn btn-dark'>Live Site</a>
                            {project?.sourseCode && <a href={project?.sourseCode} target="_blank" className='btn btn-dark'>Source Code</a>}
                            {project?.serverCode &&
                                <>
                                    <a href={project?.clientCode} className='btn btn-dark' target="_blank">Client Side</a>
                                    <a href={project?.serverCode} target='_blank' className='btn btn-dark'>Server Side</a>
                                </>}
                        </div>
                    </div>

                </div>
                <div className='col-lg-7  col-12 order-lg-1'>
                    <ProjectImageSlider images={images}></ProjectImageSlider>
                </div>
            </div>

        </div >
    );
};

export default ProjectDetail;